import QueryPromosState from '../types/QueryPromosState'

export const state: QueryPromosState = {
  events: {},
  params: {}
}
